<template>
  <div>
    <div class="container-fluid">
      <div class="form-container">
        <form method="POST" class="form py-4 col-lg-4 col-md-7 col-sm-9 col-11 mx-auto">
          <h4 class="text-center my-4 form-heading">Set a new password</h4>
          <p
            class="errors mb-4 col-lg-10 col-md-10 col-11 col-sm-10 mx-auto"
            id="error"
            v-show="NewError"
          ></p>
          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              type="password"
              placeholder="Enter new password"
              autocomplete="off"
              name="pwd"
              id="pwd"
              class="input form-control"
              v-model="password"
              required
            />
            <!-- <label class="form-label" for="pwd">New password</label> -->
          </div>
          <div class="form-group col-lg-10 col-md-10 col-11 col-sm-10 mx-auto">
            <input
              v-if="showPassword"
              type="text"
              placeholder="Confirm new password"
              autocomplete="off"
              name="pwd"
              id="pwdconf"
              class="input form-control"
              v-model="passwordConf"
              required
            />
            <input
              v-else
              type="password"
              placeholder="Confirm new password"
              autocomplete="off"
              name="pwd"
              id="pwdconf"
              class="input form-control"
              v-model="passwordConf"
              required
            />
            <!-- <label class="form-label" for="pwdconf">Confirm new password</label> -->

            <svg
              class="pwd-icon"
              v-if="!showPassword"
              @click="toggleShow"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M17.882 19.297A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.819-9a10.982 10.982 0 0 1 3.34-6.066L1.392 2.808l1.415-1.415 19.799 19.8-1.415 1.414-3.31-3.31zM5.935 7.35A8.965 8.965 0 0 0 3.223 12a9.005 9.005 0 0 0 13.201 5.838l-2.028-2.028A4.5 4.5 0 0 1 8.19 9.604L5.935 7.35zm6.979 6.978l-3.242-3.242a2.5 2.5 0 0 0 3.241 3.241zm7.893 2.264l-1.431-1.43A8.935 8.935 0 0 0 20.777 12 9.005 9.005 0 0 0 9.552 5.338L7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.592zm-9.084-9.084a4.5 4.5 0 0 1 4.769 4.769l-4.77-4.769z"
              />
            </svg>
            <!-- open eye -->
            <svg
              class="pwd-icon"
              v-if="showPassword"
              @click="toggleShow"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
            >
              <path fill="none" d="M0 0h24v24H0z" />
              <path
                d="M12 3c5.392 0 9.878 3.88 10.819 9-.94 5.12-5.427 9-10.819 9-5.392 0-9.878-3.88-10.819-9C2.121 6.88 6.608 3 12 3zm0 16a9.005 9.005 0 0 0 8.777-7 9.005 9.005 0 0 0-17.554 0A9.005 9.005 0 0 0 12 19zm0-2.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
              />
            </svg>
          </div>
          <div class="text-center mb-4">
            <button
              type="submit"
              @click.prevent="resetPwd"
              class="btn btn_styles btn-md btn-primary"
            >Update password</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
const url = "https://bookinga.herokuapp.com/api/v1/client/resetPassword/";
import axios from "axios";
import CryptoJS from "crypto-js";
import router from "./../../router/index";
export default {
  data() {
    return {
      NewError: false,
      passwordConf: "",
      password: ""
    };
  },

  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    }
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    resetPwd: function() {
      if (this.password == "" || this.passwordConf == "") {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "The two fields are all required";
      } else if (this.password.length < 6) {
        this.NewError = true;
        document.getElementById("error").innerHTML =
          "Password should be more than 5 characters";
      } else if (this.password !== this.passwordConfirm) {
        this.NewError = true;
        document.getElementById("error").innerHTML = "Passwords must match";
      } else {
        let verificationTokenObject = this.$route.query;
        let verificationToken = verificationTokenObject.txyz04eg.trim();
        verificationToken = verificationToken.replace(/ /g, "+");
        var decryptedBytes = CryptoJS.AES.decrypt(
          verificationToken,
          "UserWithiNoUrYuhfdnfhdsfshfsfdshgfsyrsbfdfsdsfdfdfdf909fdsfjfjsfjs"
        );
        let plaintext = decryptedBytes.toString(CryptoJS.enc.Utf8);
        axios
          .put("https://bookinga.herokuapp.com/api/v1/client/resetPassword", {
            Telephone: plaintext,
            password: this.password,
            confirmPassword: this.passwordConf
          })
          .then(function(response) {
            if (response.data.success == true) {
              document.getElementById("error").innerHTML =
                response.data.message;
              router.push("/");
            } else {
              this.NewError = true;
              document.getElementById("error").innerHTML =
                response.data.message;
            }
          })
          .catch(error => {
            this.NewError = true;
            document.getElementById("error").innerHTML =
              error.response.data.message;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.password-recap,
.signup {
  width: 80%;
  flex-wrap: wrap;
}
</style>
